<template>
  <div class="change-chain">
    <div class="change-chain-top-bar">
      <span class="title">{{ chainName }}</span>
      <el-button class="change-btn" @click="change()">变更</el-button>
    </div>
    <update-chain ref="updateChainRef" @updateChainName="initChain"></update-chain>
  </div>
</template>
<script>
import updateChain from './updateChain.vue'
export default {
  components: {
    updateChain
  },
  data() {
    return {
      chainName: ''
    }
  },
  mounted() {
    this.initChain()
  },
  methods: {
    initChain() {
      let id = sessionStorage.getItem('cbaas_privacy_chain_id')
        ? sessionStorage.getItem('cbaas_privacy_chain_id')
        : ''
      this.$store.commit('updateComputingChainId', id)
      this.chainName = id
    },
    change() {
      this.$refs.updateChainRef.handleOpen()
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'change-chain',
  (
    --change-chain-top-bar-bg-color: #303c65,
    --change-chain-top-bar-border: #475975,
    --change-chain-top-bar-btn-bg-color: linear-gradient(180deg, #093661 0%, #0283c2 90%),
    --change-chain-top-bar-btn-font-color: #fff,
    --change-chain-top-bar-btn-border-color: #8ed7ff
  ),
  (
    --change-chain-top-bar-bg-color: #6dd4ff,
    --change-chain-top-bar-border: #6dd4ff,
    --change-chain-top-bar-btn-bg-color: #fff,
    --change-chain-top-bar-btn-font-color: #192227,
    --change-chain-top-bar-btn-border-color: #8ed7ff
  )
);
.change-chain {
  @include adaptation(
    (
      --change-chain-top-bar-height: 55px,
      --change-chain-top-bar-border-width: 1px,
      --change-chain-top-bar-padding: 16px,
      --change-chain-top-bar-font-size: 16px,
      --change-chain-top-bar-btn-padding: 5px 15px
    )
  );
  --change-chain-min-height: var(--base-main-router-body-avaliable-height);
  color: var(--change-chain-color);
  .change-chain-top-bar {
    height: var(--change-chain-top-bar-height);
    background: var(--change-chain-top-bar-bg-color);
    border-bottom: var(--change-chain-top-bar-border-width) solid var(--change-chain-top-bar-border);
    padding: var(--change-chain-top-bar-padding);
    font-size: var(--change-chain-top-bar-font-size);
    .title {
      margin-right: var(--change-chain-top-bar-font-size);
      color: #fff;
    }
    .change-btn {
      padding: var(--change-chain-top-bar-btn-padding);
      background: var(--change-chain-top-bar-btn-bg-color);
      color: var(--change-chain-top-bar-btn-font-color);
      border: var(--change-chain-top-bar-border-width) solid
        var(--change-chain-top-bar-btn-border-color);
    }
  }
}
</style>
